import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, forwardRef } from '@angular/core';
import { IonDatetime, IonModal } from '@ionic/angular';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [DatePipe, {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatePickerComponent),
    multi: true
  }]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
  @Input() label: string;
  @Input() max: any;
  @Input() min: any;
  @Input() showIcon = true;
  @Input() placeholder = '.....';
  @Input() format = 'dd-MM-yyyy';
  @Input() presentation: 'date' | 'time' | 'date-time' = 'date';
  @Input() position: 'stacked' | 'floating' | 'inline' | undefined = 'inline';
  @ViewChild(IonDatetime) datetime: IonDatetime;
  @ViewChild(IonModal) modal: IonModal;
  @Output() dateChange = new EventEmitter<any>();
  @Input() date: any;

  onChange = (_) => { };
  onTouched = () => { };

  constructor(private dateFormat: DatePipe) { }

  ngOnInit() { }

  show(ev) {
    // this.modal.present(ev);
    this.modal.present();
  }
  get display() {
    if (this.presentation === 'time') {
      const now = new Date();
      if (!this.date) { return '00:00'; }
      console.log(':::now', now, ',,,, ', this.date);
      const els = (this.date + '').split(':');
      now.setHours(Number(els[0]), Number(els[1]));
      return this.dateFormat.transform(now, this.format || 'HH:mm');
    }
    try {
      return this.dateFormat.transform(this.date, this.format || 'dd-MM-yyyy');
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  onChanged(ev) {
    if (!this.datetime) {
      return;
    }
    console.log('Value::', ev);
    this.date = this.datetime.value;
    console.log('Value::', this.date);
    this.modal.dismiss();
    this.setValue(this.datetime.value);
    this.dateChange.emit(this.datetime.value);
    this.onChange(this.datetime.value);
  }
  setValue(value) {
    if (value != null) {
      this.date = value;
    }
  }
  writeValue(value: any): void {
    this.setValue(value);
  }

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
}
